import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'ag-code-flag-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center">
    <wiz-image *ngIf="hasIcon" [sourceObservable]="data.iconOrDie" width="24px" height="24px"></wiz-image>
    <wiz-label [wizLabel]="data.code" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgCodeFlagRenderer implements AgRendererComponent {
  data: any;

  get hasIcon(): boolean {
    return this.data && !!this.data.icon;
  }

  constructor(private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.cdref.markForCheck();
  }
}
